import { useGetOfficeInvoiceReportSettings } from '@/context/services/approving_invoice_reports/ApprovingInvoiceReports.service';
import type { InvoiceReportFormInputResponse } from '@/context/services/report_inferences/types';
import {
  type ReportInferencesMismatchViewData,
  useReportInferencesMismatchCaptions,
} from '@/hooks/report_inferences/useReportInferencesMismatchCaptions';
import { useEffect, useRef } from 'react';
import type { Dispatch, SetStateAction } from 'react';

type UseApplicationMismatchViewDataParams = {
  reportId: string;
  reportFormInputs?: InvoiceReportFormInputResponse[] | null;
  paymentTotalAmount?: string | null;
  onMismatchViewDataChange?: Dispatch<
    SetStateAction<ReportInferencesMismatchViewData | undefined>
  >;
};

export const useApplicationMismatchViewData = ({
  reportId,
  reportFormInputs,
  paymentTotalAmount,
  onMismatchViewDataChange,
}: UseApplicationMismatchViewDataParams):
  | ReportInferencesMismatchViewData
  | undefined => {
  const { data: officeInvoiceReportSettings } =
    useGetOfficeInvoiceReportSettings();
  const reportTypeId =
    officeInvoiceReportSettings?.data?.invoice_report_type?.id ?? '';
  const mismatchViewData = useReportInferencesMismatchCaptions(
    reportId,
    reportTypeId,
    {
      reportFormInputs,
      paymentTotalAmount,
    }
  );
  const onMismatchViewDataChangeRef = useRef(onMismatchViewDataChange);

  useEffect(() => {
    onMismatchViewDataChangeRef.current = onMismatchViewDataChange;
  }, [onMismatchViewDataChange]);

  useEffect(() => {
    onMismatchViewDataChangeRef.current?.(mismatchViewData);
  }, [mismatchViewData]);

  return mismatchViewData;
};
